import { z } from 'zod'

/**
 * Identifies which sample entity `OperationContract.sampleData` should
 * resolve for preview purposes. `kind` is host-defined (e.g. `'product'`
 * for the ANB embedded adapter); `id` looks up a specific entity; `query`
 * carries loose lookup keys (e.g. `{ code }` or `{ name }`) when `id` is
 * not known. Adapters that don't recognise `kind` return `UNSUPPORTED`.
 */
export const SampleDataRefSchema = z.object({
  kind: z.string(),
  id: z.string().optional(),
  query: z.record(z.string(), z.unknown()).optional(),
})
export type SampleDataRef = z.infer<typeof SampleDataRefSchema>
